import { useEffect, useState } from 'react';
import { useEmployeeApi } from '@apis/useEmployeeApi';

// 取得員工資訊
const useGetEmployeeInformationState = ({ isFetchOnMount = true, employeeID = 0 } = {}) => {
    const { getEmployeeInformationApi: doEmployeeInformationApi } = useEmployeeApi();
    const [sourceData, setSourceData] = useState([]);

    const getEmployeeInformationApi = async (employeeID) => {
        const resp = await doEmployeeInformationApi(employeeID);
        if (resp) {
            setSourceData(resp);
        }
    };

    useEffect(() => {
        let isMounted = true;
        if (isFetchOnMount && employeeID) {
            (async () => {
                const resp = await doEmployeeInformationApi(employeeID);
                if (isMounted && resp) setSourceData(resp);
            })();
        }
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line
    }, [isFetchOnMount, employeeID]);

    return { sourceData, getEmployeeInformationApi };
};

export default useGetEmployeeInformationState;
